import { Button, Select } from 'antd'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import React, { useContext, useState } from 'react'
import { getMonths, getYears } from './config'
import './index.scss'

type OnChangeFunction = (date: Dayjs) => void

type HeaderRenderProps = {
  value: Dayjs
  onChange: OnChangeFunction
  calendarYearRange: number
}

type YearsList = Array<{
  value: number
  label: string
}>

function handleOnChange(
  onChange: OnChangeFunction,
  month: number,
  year: number,
  setMonth: React.Dispatch<React.SetStateAction<number>>,
  setYear: React.Dispatch<React.SetStateAction<number>>,
) {
  const date = dayjs(`${year}-${month}-1`)
  setMonth(Number(date.format('MM')))
  setYear(Number(date.format('YYYY')))
  onChange(date)
}

function disableNextMonth(month: number, year: number, allowedYears: YearsList) {
  return month >= 12 && year >= allowedYears[allowedYears.length - 1].value
}

function disablePreviousMonth(month: number, year: number, allowedYears: YearsList) {
  return month <= 1 && year <= allowedYears[0].value
}

export default function HeaderRender({ value, onChange, calendarYearRange }: HeaderRenderProps) {
  const [month, setMonth] = useState(Number(value.format('MM')))
  const [year, setYear] = useState(Number(value.format('YYYY')))
  const currentYear = new Date().getFullYear()
  const years = getYears(currentYear, calendarYearRange)
  const today = dayjs(Date.now())
  const t = useContext(I18nContext)

  return <div className='calendar-header-container'>
    <div className="date-controller">
      <Button disabled={disablePreviousMonth(month, year, years)} onClick={() => handleOnChange(onChange, month - 1, year, setMonth, setYear)}>{'<'}</Button>
      <Select
        value={month}
        options={getMonths(t)}
        onChange={(calendarValue) => handleOnChange(onChange, calendarValue, year, setMonth, setYear)}
      />
      <Select
        value={year}
        options={years}
        onChange={(calendarValue) => handleOnChange(onChange, month, calendarValue, setMonth, setYear)}
      />
      <Button disabled={disableNextMonth(month, year, years)} onClick={() => handleOnChange(onChange, month + 1, year, setMonth, setYear)}>{'>'}</Button>
    </div>
    <Button className="today-button" onClick={() => {
      handleOnChange(onChange, today.get('month') + 1, today.get('year'), setMonth, setYear)
    }}>
      {t('general.calendar.today')}
    </Button>
  </div>
}
